import React from "react";
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

type Props = {
  rows?: number;
  columns?: number;
};

export function TableSkeleton({ rows = 6, columns = 5 }: Props) {
  return (
    <TableContainer
      style={{
        borderRadius: "8px",
        overflow: "hidden",
        border: "1px solid #f0f0f0",
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <TableCell key={colIndex} style={{ padding: "16px" }}>
                <Skeleton variant="text" width="60%" animation="wave" />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from({ length: columns }).map((__, colIndex) => (
                <TableCell key={colIndex} style={{ padding: "16px" }}>
                  <Skeleton variant="text" animation="wave" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
